import type { Component } from 'vue';
import PageTitle from './PageTitle.vue';
import PopupTitle from './PopupTitle.vue';
import ProjectTitle from './ProjectTitle.vue';

export default new Map<string, Component>([
  ['PageTitle', PageTitle],
  ['ProjectTitle', ProjectTitle],
  ['PopupTitle', PopupTitle],

]);



